import {
    CORE_LOAD_MANAGE_GROUPS_REQUEST,
    CORE_LOAD_MANAGE_GROUPS_SUCCESS,
    CORE_LOAD_MANAGE_GROUPS_FAILURE,

    CORE_LOAD_MANAGE_GROUP_REQUEST,
    CORE_LOAD_MANAGE_GROUP_SUCCESS,
    CORE_LOAD_MANAGE_GROUP_FAILURE,

} from '../../manageTypes'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    manageGroups: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MANAGE_GROUPS_REQUEST:
                return state
            case CORE_LOAD_MANAGE_GROUPS_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_LOAD_MANAGE_GROUPS_FAILURE:
                return []
            default:
                return state
        }
    },
    manageGroup: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MANAGE_GROUP_REQUEST:
                return state
            case CORE_LOAD_MANAGE_GROUP_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_LOAD_MANAGE_GROUP_FAILURE:
                return {}
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/manage/group.js